import { useEffect } from "react";
import { useParams } from "react-router-dom";
import "./Part.scss";
import { useState } from "react";
import { api } from "../../services/api/api";
import Loading from "../../components/loading/Loading";
import { Breadcrumb } from "../../components/breadcrumb/Breadcrumb";
import { Card, Typography } from "@material-tailwind/react";
import { t } from "i18next";
import { isPolandRealm } from "../../services/utils/utils";
import { getPartTypeI18nKey } from "../../services/utils/partTypeUtils";
import { hasExternalId, isOdooConnected } from "../../services/odoo/odoo";

export function Part() {
  const { id } = useParams();
  const [part, setPart] = useState<EasyTech.Part>();
  const [path, setPath] = useState<{ name: string; path: string }[]>([]);

  useEffect(() => {
    api.get(`users/parts/${id}`).then((ret) => {
      setPart(ret as EasyTech.Part);
    });
  }, [id]);


  useEffect(() => {
    if (part) {
      setPath([
        { name: t("common:parts"), path: "/parts" },
        { name: part.label, path: `/parts/${part.id}` },
      ]);
    }
  }, [part]);


  return (
    <div className="part-details">
      {part ? (
        <>
          <Breadcrumb path={path} />

          <div className="flex justify-between items-center">
            <Typography variant="h2">{part.label}</Typography>
          </div>

          <Typography variant="h4" className="sub-title">
            {t("piece:informations")}
          </Typography>

          <Card className="details-card">
            <div className="field">
              <label>{t("common:name")}</label>
              <Typography>{part.label}</Typography>
            </div>

            <div className="field">
              <label>{t("common:ref:label")}</label>
              <Typography>{part.ref}</Typography>
            </div>

            <div className="field">
              <label>{t("common:sellingPrice")}</label>
              <Typography>{part.price}</Typography>
            </div>

            {part.type && (
              <div className="field">
                <label>{t("common:type")}</label>
                <Typography>
                  {getPartTypeI18nKey(part.type) ? t(getPartTypeI18nKey(part.type)!) : part.type}
                </Typography>
              </div>
            )}

            <div className="field">
              <label>{t("common:category")}</label>
              <Typography>{part.category?.label || "-"}</Typography>
            </div>

            <div className="field">
              <label>{t("common:unity")}</label>
              <Typography>{part.unity || "-"}</Typography>
            </div>

            {isPolandRealm() && part.barcode && (
              <div className="field">
                <label>{t("piece:barcode")}</label>
                <Typography>{part.barcode}</Typography>
              </div>
            )}

            {/*
              * Affiché dès que le realm est relié à Odoo, y compris quand l'article n'est pas encore
              * synchronisé : c'est précisément l'absence de lien que le lecteur cherche à constater.
              * Même règle et même formulation que l'onglet Informations d'une fiche client.
              */}
            {isOdooConnected() && (
              <div className="field">
                <label>{t("piece:odoo:externalId:label")}</label>
                <Typography>
                  {hasExternalId(part.externalId)
                    ? part.externalId
                    : t("piece:odoo:externalId:notSynced")}
                </Typography>
              </div>
            )}
          </Card>
        </>
      ) : (
        <Loading />
      )}
    </div>
  );
}
